<template>
  <div class="kit-color-picker">
    <el-row>
      <el-col
        class="kit-color-picker__type"
        :lg="12" :md="12" :sm="12" :xs="24"
      >
        <el-form-item
          :label="fields.type.label"
          :prop="fields.type.name"
          :required="fields.type.required"
        >
          <el-select
            v-model="model.jersey.type"
            clearable
            @clear="onTypeClear"
          >
            <i
              class="icon-tshirt"
              slot="prefix"
            />
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.type.options"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
          <app-kit-piece-color-picker
            v-model="model.jersey"
            piece="jersey"
            :type="model.jersey.type"
            code="entities.teamRegistration.fields.clubKitJersey"
          />
      </el-col>
      <el-col :lg="12" :md="12" :sm="12" :xs="24">
          <app-kit-piece-color-picker
            v-model="model.pants"
            piece="pants"
            :type="model.jersey.type"
            code="entities.teamRegistration.fields.clubKitPants"
          />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash'

import { i18n } from '@shared/i18n'

import AppKitPieceColorPicker from '@/components/KitPieceColorPicker.vue'

import { ClubKitPieceModel } from '@/models/club-kit-piece-model'

const { fields } = ClubKitPieceModel

export default {
  name: 'appKitColorPicker',
  props: {
    value: Object,
  },
  data() {
    return {
      model: {
        jersey: {
          color1: null,
          color2: null,
          type: null,
        },
        pants: {
          color1: null,
        },
      },
      fields,
      i18n,
    }
  },
  methods: {
    onTypeClear() {
      this.model = {
        jersey: {
          color1: null,
          color2: null,
          type: null,
        },
        pants: {
          color1: null,
        },
      }
      this.$emit('clear')
    },
  },
  components: {
    AppKitPieceColorPicker,
  },
  computed: {
    watchedModel: function() {
      // https://github.com/vuejs/vue/issues/2164
      return JSON.stringify(this.model)
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (!val) return
        if (_.isEqual(val, oldVal)) return
        if (val.jersey) this.model.jersey = val.jersey
        if (val.pants) this.model.pants = val.pants
      },
      deep: true,
      immediate: true,
    },
    watchedModel: {
      handler(val, oldVal) {
        if (val === oldVal) return
        this.$emit('input', this.model)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.kit-color-picker {
  &__type {
    padding: 0 56px 0 40px;
    height: 80px;

    @include tablet {
      padding: 0 40px 0 24px;
    }
  }
}
</style>